import { Box, Typography } from '@mui/material';
import { TextInput } from '@uplift/ui-v2';
import { useFormikContext } from 'formik';
import { ProfileForm } from './types';
import { useEffect, useRef, useState } from 'react';
import { useProfileStyles } from '../styles';
import { useIsMobile } from '@uplift/hooks';

const getZeroFilled = (length: number) => length.toString().padStart(3, '0');

const ROW_HEIGHT = 19;

export const BioForm: React.VFC = () => {
  const isMobile = useIsMobile('sm');
  const { classes } = useProfileStyles();
  const ref = useRef<HTMLDivElement>(null);
  const formik = useFormikContext<ProfileForm['bio']>();
  const [ height, setHeight ] = useState<number>(0);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      window.requestAnimationFrame((): void | undefined => {
        if (Array.isArray(entries) && entries.length) {
          setHeight(entries[0].contentRect.height);
        }
      });
    });

    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up
  }, []);

  const inputHeight = Math.round(height) - 20 - 28; // 20 for the length text, 32 for the padding
  const rows = Math.round(inputHeight / ROW_HEIGHT);

  return (
    <div ref={ref} className={classes.height100}>
      <TextInput
        name="bio"
        fullWidth
        multiline
        minRows={isMobile ? rows : 12}
        maxCharacters={700}
      />
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="body2" color="textSecondary">{getZeroFilled(formik.values.bio.length)}/700</Typography>
      </Box>
    </div>
  );
};
